import { ReactElement } from 'react';
import { alpha, Box, Typography } from '@mui/material';
import BigNumber from 'bignumber.js';

import { DECIMAL_PLACES_SHORT } from 'modules/common/const';
import { useGlobalTranslation } from 'modules/i18n';

interface ISummaryItemProps {
  label: string;
  value: string | ReactElement;
  usdValue?: BigNumber;
}

export function SummaryItem({
  label,
  value,
  usdValue,
}: ISummaryItemProps): ReactElement {
  const { t, keys } = useGlobalTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
      }}
    >
      <Typography
        color={theme => alpha(theme.palette.text.primary, 0.6)}
        variant="body1"
      >
        {label}:
      </Typography>

      <Typography
        sx={theme => ({
          display: 'inline-flex',
          alignItems: 'center',
          columnGap: theme.spacing(1.5),
          justifyContent: 'flex-end',
          flexWrap: 'wrap',
        })}
        variant="body1"
      >
        {value}

        {usdValue && (
          <Box
            sx={theme => ({
              color: theme.palette.text.secondary,
            })}
          >
            {t(keys.unit.$, {
              value: usdValue.decimalPlaces(DECIMAL_PLACES_SHORT).toFormat(),
            })}
          </Box>
        )}
      </Typography>
    </Box>
  );
}
